export enum InviteState {
  ACCEPTED = 'accepted',
  PENDING = 'pending',
}
